import Logger from "../lib/logger"
import consumer from "./consumer"

const testChannel = consumer.subscriptions.create("TestChannel", {
  connected() {
    Logger.debug("🔌 TestChannel: Connected to test channel")
  },

  disconnected() {
    Logger.debug("🔌 TestChannel: Disconnected from test channel")
  },

  received(data) {
    Logger.debug("🔌 TestChannel: Received data:", data)
  },

  test_message(message) {
    this.perform('test_message', { message: message })
  }
})

export default testChannel
